import React from 'react';
import { Link } from 'react-router-dom';

import history from '../history';
// import Snakewoman from '../../sketches/snakewoman';
// import Garden from '../../sketches/garden';
// import Child from '../../sketches/child';
// import ClumsyForest from '../../sketches/clumsyforest';
// import Sentinel from '../../sketches/sentinel';
// import SpaceOcean from '../../sketches/spaceocean';
// import SphericalMirrors from '../../sketches/sphericalmirrors';
// import Incantation from '../../sketches/incantation';
// import ThreeBone from '../../sketches/threebone';
// import ArmFoot from '../../sketches/armfoot';
// import Mira from '../../sketches/mira';
// import Broken from '../../sketches/broken';
// import Thought from '../../sketches/thought';
// import Christmas from '../../sketches/christmas';
// import LiquidBody from '../../sketches/liquidbody';
// import Underwater from '../../sketches/underwater';
// import Tiny from '../../sketches/tiny';


export default class SketchItem extends React.Component {

    openSketch() {
        history.push(this.props.sketch.url);
        return (
            <>
                <Link to={`/webgl/${this.props.sketch.id}`}>
                </Link>
            </>
        );
    };

    // renderSketch() {
    //     switch (this.props.match.params.id) {
    //         case 'snakewoman':
    //             return <Snakewoman />;
    //         case 'garden':
    //             return <Garden />;
    //         case 'child':
    //             return <Child />;
    //         case 'garden':
    //             return <Garden />;
    //         case 'garden':
    //             return <Garden />;
    //         case 'garden':
    //             return <Garden />;
    //         case 'garden':
    //             return <Garden />;
    //         case 'garden':
    //             return <Garden />;
    //         case 'garden':
    //             return <Garden />;
    //         default: return <div>Oops</div>;
    //     }
    // }

    render() {
        return (
            <>
                <img className="Sketch-Item"
                    src={this.props.sketch.cover}
                    alt={this.props.sketch.title}
                    onClick={() => this.openSketch()}
                />
            </>
            // <>
            //     {this.renderSketch()}
            // </>
        )
    }
}